export function compactSingle(data, shape) {
  const s = data.summary || {};
  const reasons = (data.top_downtime_reasons || [])
    .slice(0, 5);
  const id = (shape.machineId || "").trim().toLowerCase();
  const byMachine = (data.by_machine || [])
    .filter(r => id === "" || ((r.machineId || "").toLowerCase() === id.toLowerCase())) //if we have a machineId passed in by the user then filter by it

  return {
    context: data.context,
    summary: id === "" ? s : {}, //only include the summary if there's more than one machine.
    // {
    //   machines_reporting: s.machines_reporting,
    //   utilization_pct: s.utilization_pct,
    //   part_count_total: s.part_count_total,
    //   downtime_hours: s.downtime_minutes / 60,
    //   unlabeled_hours: s.unlabeled_minutes / 60,
    //   uptime_hours: s.uptime_hours
    // },
    top_downtime_reasons: id === "" ? reasons : [],
    by_machine: byMachine
  };
}

// compactMachineState (utils/compact.js) — enforce selection BEFORE sending to LLM
export function compactMachineState(data, shape) {
  const all = (data.by_machine || []).map(r => ({
    machineId: r.machineId,
    status: (r.status || "").toLowerCase(),
    status_duration_minutes: Number(r.status_duration_minutes || 0),
  }));

  const { machineId = "", statusFilter = "any" } = (shape || {});
  let rows = all;

  //If we ask questions about a particular machine i.e. Is Mill_01 stopped and it's running then the
  //statusFilter is set to off and the LLM summarizer will not return anything.  
  //But if we want to know about a collection of machines with a status of on|off then machineId is empty
  //THIS DID WORK.  Questions need to ask, 'what is the status of Mill_01' vs Is Mill_01 a particular state.
  //   if (machineId != "")
  //   {
  //     statusFilter="any"
  //   }
  if (machineId && machineId.toLowerCase() !== "all") {
    rows = all.filter(r => (r.machineId || "").toLowerCase() === machineId.toLowerCase());
  } else if (statusFilter === "on" || statusFilter === "off") {
    rows = all.filter(r => r.status === statusFilter);
  }
  else if (statusFilter && statusFilter != "all") {
    console.log("statusFilter: " + statusFilter)
    rows = all.filter(r => r.status.toLowerCase().includes(statusFilter.toLowerCase()));
  }

  rows.sort((a, b) => b.status_duration_minutes - a.status_duration_minutes);
  return { rows, statusFilter };
}


//10/29/2025 this does not appear to be called from anywhere
// export function compactMulti(results, shape) {
//   // Keep each window’s summary and top producers only; LLM can infer trends
//   return results.map((d, idx) => {
//     const s = d.summary || {};
//     const id = (shape.machineId || "").trim().toLowerCase();
//     const topMachines = (d.by_machine || [])
//       .filter(r => id === "" || ((r.machineId || "").toLowerCase() === id.toLowerCase())) //if we have a machineId then use it
//       .sort((a, b) => (b.uptime_hours_total || 0) - (a.uptime_hours_total || 0))
//       .slice(0, 3)
//       .map(m => ({
//         machineId: m.machineId,
//         part_count_total: m.part_count_total,
//         utilization_avg: m.utilization_avg,
//         uptime_hours_total: m.uptime_hours_total,
//       }));
//     return {
//       index: idx,
//       context: d.context,
//       summary: {
//         machines_reporting: s.machines_reporting,
//         part_count_total: s.part_count_total,
//         utilization_pct: s.utilization_pct,
//         uptime_hours: s.uptime_hours
//       },
//       top: topMachines
//     };
//   });
// }

export function inferLabel(shape) {
  const g = (shape.granularity || "").toLowerCase();
  if (g === "week") return "Week-over-week";
  if (g === "month") return "Month-over-month";
  if (g === "quarter") return "Quarter-over-quarter";
  if (g === "year") return "Year-over-year";
  return "Comparison";
}


// compact.js

function fmtDateMMDDYY(iso) {
  if (!iso) return "";
  const d = new Date(iso);

  // Use UTC methods to avoid timezone conversion
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0"); // getUTCMonth()
  const dd = String(d.getUTCDate()).padStart(2, "0");     // getUTCDate()
  const yy = String(d.getUTCFullYear()).slice(-2);  // getUTCFullYear()

  return `${mm}/${dd}/${yy}`;
}

/**
 * Compact multiple getShiftSummary results into a lightweight structure
 * suitable for passing to the LLM summarizer for comparisons/trends.
 *
 * @param {Array} results - Array of getShiftSummary responses
 * @param {Object} shape  - Shape returned from the LLM (intent, granularity, etc.)
 * @returns {Object} compacted payload with windows[]
 */
export function compactMultiSummaries(results, shape) {
  if (!Array.isArray(results) || results.length === 0) {
    return { windows: [] };
  }

  const windows = results.map((data, idx) => {
    const s = data.summary || {};
    const ctx = data.context || {};
    const id = (shape.machineId || shape.intent_detail?.machineId || "").trim().toLowerCase();
    let rows = data.by_machine
    if (id !== "all" && id !="") {
      rows = (data.by_machine||[]).filter(r => (r.machineId || "").toLowerCase() === id);
    }
    const downtimeReasons = (data.top_downtime_reasons || []).slice(0, 5);
    const topMachines = (rows || [])
      //.filter(r => id === "" || ((r.machineId || "").toLowerCase() === id.toLowerCase())) //if we have a machineId then use it
      .sort((a, b) => (b.uptime_hours_total || 0) - (a.uptime_hours_total || 0))
      .slice(0, 3)
      .map(m => ({
        machineId: m.machineId,
        part_count_total: m.part_count_total,
        utilization_avg: m.utilization_avg,
        uptime_hours_total: m.uptime_hours_total,
      }));

    return {
      index: idx,
      range: {
        dateStart: fmtDateMMDDYY(ctx.dateStart || ctx.date || null),
        dateEnd: fmtDateMMDDYY(ctx.dateEnd || ctx.date || null),
        shiftName: ctx.shiftName || ""
      },
      summary: id === "" ? { //don't include this summary if 1 machine is inquired about b/c the summary is specific to all machines
        machines_reporting: s.machines_reporting,
        part_count_total: s.part_count_total,
        utilization_pct: s.utilization_pct,
        uptime_hours: s.uptime_hours
      } : {},
      top_downtime_reasons: id === "" ? downtimeReasons : [],
      top: topMachines
    };
  });

  return {
    intent: "compare",
    granularity: shape.granularity || null,
    shiftName: shape.shiftName || null,
    metric: shape.metric || null,
    windows
  };
}

